import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 30000, // Timeout global
  maxContentLength: 50 * 1024 * 1024, // 50MB
  maxBodyLength: 50 * 1024 * 1024, // 50MB
});



 
// Service d'authentification
export const authService = {
  login: async (credentials) => {
    try {
      const response = await api.post('/login', credentials);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
 
    // NOUVELLE MÉTHODE : Renvoyer l'email de vérification
  resendVerificationEmail: async () => {
    try {
      const response = await api.post('/email/verification-notification');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // NOUVELLE MÉTHODE : Vérifier si l'email est vérifié
  checkEmailVerification: async (userId, hash) => {
    try {
      const response = await api.get(`/verify-email/${userId}/${hash}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  resetPassword: async (token, email, password, password_confirmation) => {
    try {
      const response = await api.post('/password/reset', {
        token,
        email,
        password,
        password_confirmation
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  
forgotPassword: async (email) => {
    try {
      const response = await api.post('/password/forgot', { email });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  
 register: async (userData) => {
  try {
    const response = await api.post('/register', userData, {
      headers: {
        'Content-Type': 'multipart/form-data', // AJOUTEZ CETTE LIGNE
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
},

 getProfile: async () => {
  try {
    const response = await api.get('/me');
    const user = response.data;
    
    // Normaliser l'URL de l'image comme dans expertService
    if (user.image) {
      if (user.image.startsWith('http')) {
        user.image_url = user.image;
      } else {
        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const fileName = user.image.split('/').pop();
        user.image_url = `${baseUrl}/storage/annonces/${fileName}`;
      }
    }
    
    // Utiliser image_url du backend s'il existe
    if (!user.image_url && user.image_url_from_backend) {
      user.image_url = user.image_url_from_backend;
    }
    
    return user;
  } catch (error) {
    handleApiError(error);
  }
},

  logout: async () => {
    try {
      await api.post('/logout');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },
// Dans votre fichier api.js, modifiez la fonction updateProfile
updateProfile: async (userData) => {
  try {
    const token = localStorage.getItem('token');
    
    // COMPRESSER L'IMAGE SI NÉCESSAIRE (comme dans votre code original)
    if (userData instanceof FormData) {
      const compressedFormData = await compressImageInFormData(userData);
      if (compressedFormData !== userData) {
        console.log('Image compressée avant envoi');
        userData = compressedFormData;
      }
      
      // AJOUTER _method PUT POUR FormData
      userData.append('_method', 'PUT');
    }

    const instance = axios.create({
      baseURL: API_URL,
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    console.log('=== ENVOI UPDATE PROFILE ===');
    console.log('Type données:', userData instanceof FormData ? 'FormData' : 'JSON');
    
    // LOG DÉTAILLÉ
    if (userData instanceof FormData) {
      console.log('Contenu FormData:');
      for (let [key, value] of userData.entries()) {
        console.log(`  ${key}:`, value instanceof File ? 
          `Fichier "${value.name}" (${value.size} bytes)` : 
          typeof value === 'string' && value.length > 100 ? 
          `${value.substring(0, 50)}... (${value.length} chars)` : 
          value
        );
      }
    }

    const response = await instance.post(`/profile`, userData);
    
    console.log('=== RÉPONSE PROFILE ===');
    console.log('Statut:', response.status);
    
    // NORMALISER L'URL DE L'IMAGE
    const normalizeImageUrl = (imagePath) => {
      if (!imagePath) return null;
      if (imagePath.startsWith('http')) return imagePath;
      
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const fileName = imagePath.split('/').pop();
      return `${baseUrl}/storage/annonces/${fileName}?t=${Date.now()}`;
    };
    
    if (response.data) {
      const user = response.data.user || response.data;
      if (user.image) {
        user.image_url = normalizeImageUrl(user.image);
        console.log('URL image:', user.image_url);
      }
    }
    
    return response.data;
    
  } catch (error) {
    console.error('ERREUR UPDATE PROFILE:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      code: error.code
    });
    
    // TENTATIVE AVEC FETCH SI AXIOS ÉCHOUE
    if (error.code === 'ERR_NETWORK' && userData instanceof FormData) {
      try {
        console.log('Tentative avec fetch...');
        const fetchResult = await updateProfileWithFetch(userData);
        return fetchResult;
      } catch (fetchError) {
        console.error('Échec fetch aussi:', fetchError);
      }
    }
    
    // RELANCER L'ERREUR STRUCTURÉE
    throw {
      code: error.code || 'UNKNOWN_ERROR',
      message: error.response?.data?.message || error.message,
      errors: error.response?.data?.errors,
      status: error.response?.status
    };
  }
}
};

// Fonction alternative utilisant fetch pour contourner les problèmes HTTP2
const updateProfileWithFetch = async (formData) => {
  const token = localStorage.getItem('token');
  
  console.log('Tentative d\'envoi avec fetch...');
  
  try {
    const response = await fetch(`${API_URL}/profile`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        // Ne pas définir Content-Type pour FormData
      },
      body: formData,
      // Options pour éviter les problèmes HTTP/2
      credentials: 'same-origin',
      redirect: 'follow',
      mode: 'cors',
      cache: 'no-cache'
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        errorData = { message: `Erreur ${response.status}: ${response.statusText}` };
      }
      
      throw {
        status: response.status,
        data: errorData,
        message: `Erreur ${response.status}: ${response.statusText}`
      };
    }

    const data = await response.json();
    console.log('Réponse fetch reçue:', data);
    return data;

  } catch (error) {
    console.error('Erreur avec fetch:', error);
    
    // Compresser l'image et réessayer si l'erreur persiste
    if (error.message?.includes('network') || error.message?.includes('failed')) {
      const compressedFormData = await compressImageInFormData(formData);
      if (compressedFormData !== formData) {
        console.log('Réessai avec image compressée...');
        return updateProfileWithFetch(compressedFormData);
      }
    }
    
    throw {
      code: 'FETCH_ERROR',
      message: 'Échec de la requête avec fetch. Veuillez réessayer plus tard.',
      originalError: error
    };
  }
};

// Fonction utilitaire pour compresser l'image dans FormData
const compressImageInFormData = async (formData) => {
  const imageFile = formData.get('image');
  
  // Si pas d'image ou image déjà petite, retourner le FormData original
  if (!(imageFile instanceof File) || imageFile.size <= 1024 * 1024) { // 1MB
    return formData;
  }

  try {
    console.log(`Compression de l'image: ${imageFile.name} (${imageFile.size} bytes)`);
    
    // Créer un nouveau FormData avec l'image compressée
    const newFormData = new FormData();
    
    // Copier tous les champs sauf l'image
    for (let [key, value] of formData.entries()) {
      if (key !== 'image') {
        newFormData.append(key, value);
      }
    }
    
    // Compresser l'image
    const compressedImage = await compressImageFile(imageFile);
    newFormData.append('image', compressedImage, compressedImage.name);
    
    console.log(`Image compressée: ${compressedImage.name} (${compressedImage.size} bytes)`);
    
    return newFormData;
    
  } catch (compressError) {
    console.error('Erreur lors de la compression:', compressError);
    return formData; // Retourner l'original en cas d'erreur
  }
};

// Fonction de compression d'image
const compressImageFile = (file) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      resolve(file);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Dimensions maximales
        const MAX_WIDTH = 1200;
        const MAX_HEIGHT = 1200;
        
        // Redimensionner si nécessaire
        if (width > MAX_WIDTH || height > MAX_HEIGHT) {
          if (width > height) {
            height = Math.round((height * MAX_WIDTH) / width);
            width = MAX_WIDTH;
          } else {
            width = Math.round((width * MAX_HEIGHT) / height);
            height = MAX_HEIGHT;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Qualité de compression (0.7 = 70%)
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });
              resolve(compressedFile);
            } else {
              resolve(file);
            }
          },
          'image/jpeg',
          0.7 // Qualité
        );
      };
      
      img.onerror = () => {
        console.warn('Erreur de chargement de l\'image, utilisation du fichier original');
        resolve(file);
      };
    };
    
    reader.onerror = () => {
      console.warn('Erreur de lecture du fichier, utilisation du fichier original');
      resolve(file);
    };
  });
};



// Service des annonces
export const annonceService = {
  getAll: async (page = 1, search = '') => {
    try {
      const response = await api.get('/annonces', {
        params: { page, search }
      });
      
      console.log('API Response - Annonces list:', response.data);
      
      // Normaliser les URLs d'images de la même manière que dans DetailAnnonce.js
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        response.data.data = response.data.data.map(annonce => {
          // Même logique que dans DetailAnnonce.js
          if (annonce.image) {
            // Si l'image est déjà une URL complète
            if (annonce.image.startsWith('http')) {
              annonce.image_url = annonce.image;
            } 
            // Si c'est un chemin relatif
            else {
              // Extraire juste le nom du fichier (après le dernier /)
              const fileName = annonce.image.split('/').pop();
              const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
              annonce.image_url = `${baseUrl}/storage/annonces/${fileName}`;
            }
          }
          
          return annonce;
        });
      }
      
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  getOne: async (id) => {
    try {
      const response = await api.get(`/annonces/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
   create: async (data) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      };
      
      // Récupérer le profil utilisateur pour obtenir l'ID
      const token = localStorage.getItem('token');
      if (token) {
        try {
          // Vous pouvez aussi stocker l'ID utilisateur dans localStorage après connexion
          const userData = JSON.parse(localStorage.getItem('user') || '{}');
          if (userData && userData.id) {
            // Si l'user_id n'est pas déjà dans le FormData, l'ajouter
            if (data instanceof FormData) {
              data.append('user_id', userData.id);
            }
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données utilisateur:', error);
        }
      }
      
      const response = await api.post('/annonces', data, config);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

update: async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    
    const instance = axios.create({
      baseURL: API_URL,
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    if (data instanceof FormData) {
      data.append('_method', 'PUT');
    }

    console.log('=== ENVOI REQUÊTE UPDATE ===');
    console.log('URL:', `/annonces/${id}`);
    console.log('Headers:', instance.defaults.headers);
    console.log('Data (FormData):');
    for (let [key, value] of data.entries()) {
      console.log(`${key}:`, value);
    }

    const response = await instance.post(`/annonces/${id}`, data);
    
    console.log('=== RÉPONSE API ===');
    console.log('Statut:', response.status);
    console.log('Données complètes:', JSON.stringify(response.data, null, 2));
    
    // FORCER l'ajout de l'URL de l'image si elle n'est pas présente
    if (response.data && response.data.data) {
      const annonce = response.data.data;
      
      // Vérifier si l'API a retourné une nouvelle image
      if (annonce.image) {
        console.log('Image retournée par API:', annonce.image);
        
        // Construire l'URL complète avec timestamp
        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        
        // Vérifier le format de l'image retournée
        if (annonce.image.startsWith('http')) {
          annonce.image_url = annonce.image;
        } else {
          // Extraire le nom du fichier
          const fileName = annonce.image.split('/').pop();
          // Ajouter timestamp pour éviter le cache
          annonce.image_url = `${baseUrl}/storage/annonces/${fileName}?t=${Date.now()}`;
        }
        
        console.log('URL image construite:', annonce.image_url);
      } else {
        console.log('⚠️ Aucune image retournée par l\'API');
      }
    }
    
    return response.data;
  } catch (error) {
    console.error('=== ERREUR UPDATE ===');
    console.error('Message:', error.message);
    console.error('Response:', error.response?.data);
    throw error;
  }
},

delete: async (id) => {
  try {
    console.log('Suppression de l\'annonce ID:', id);
    
    // Créer une instance avec le token
    const token = localStorage.getItem('token');
    const instance = axios.create({
      baseURL: API_URL,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      }
    });
    
    const response = await instance.delete(`/annonces/${id}`);
    
    console.log('Réponse suppression:', response.data);
    
    // Gestion des différentes structures de réponse
    if (response.status >= 200 && response.status < 300) {
      return {
        success: true,
        message: response.data?.message || 'Annonce supprimée avec succès',
        data: response.data,
        deletedId: id
      };
    }
    
    throw new Error(response.data?.message || 'Échec de la suppression');
    
  } catch (error) {
    console.error('Erreur détaillée lors de la suppression:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    // Renvoyer un objet d'erreur structuré
    const errorObj = {
      message: error.response?.data?.message || error.message,
      status: error.response?.status,
      data: error.response?.data,
      success: false
    };
    
    throw errorObj;
  }
},
    getUserAnnonces: async () => {
    try {
      const response = await api.get('/user/annonces');
      // Normalise la réponse pour toujours retourner un tableau
      return Array.isArray(response.data) 
        ? response.data 
        : (response.data?.data || []);
    } catch (error) {
      console.error("API Error:", error);
      throw new Error(error.response?.data?.message || "Failed to fetch annonces");
    }
  }
};

// Service des catégories
export const categorieService = {
  getAll: async () => {
    try {
      const response = await api.get('/categories');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  getAnnoncesByCategory: async (categoryId) => {
    try {
      const response = await api.get(`/categories/${categoryId}/annonces`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  getAnnoncesBySubService: async (subServiceId) => {
    try {
      const response = await api.get(`/sous-services/${subServiceId}/annonces`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

    searchAnnonces: async (searchTerm) => {
    try {
      const response = await api.get('/annonces/search', {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }

    
  },

    // NOUVELLE MÉTHODE : Recherche avancée avec filtres
  advancedSearch: async (filters) => {
    try {
      // Préparer les paramètres de la requête
      const params = {};
      
      if (filters.search) params.search = filters.search;
      if (filters.ville) params.ville = filters.ville;
      if (filters.service) params.service = filters.service;
      if (filters.categorie_id) params.categorie_id = filters.categorie_id;
      if (filters.profil) params.profil = filters.profil;
      if (filters.type) params.type = filters.type;
      if (filters.prix_min) params.prix_min = filters.prix_min;
      if (filters.prix_max) params.prix_max = filters.prix_max;
      
      // Récupérer également les annonces par sous-service si spécifié
      const response = await api.get('/annonces/advanced-search', { params });
      
      // Extraire les annonces de la réponse
      if (response.data && response.data.data) {
        return response.data.data.data || response.data.data;
      }
      
      return response.data || [];
    } catch (error) {
      console.error('Erreur recherche avancée:', error);
      handleApiError(error);
    }
  }
};

// Service des événements
export const evenementService = {
   getAll: async (page = 1) => {
    try {
      const response = await api.get('/evenements', { params: { page } });
      
      // CORRECTION : Normaliser les URLs d'images comme pour les annonces
      if (response.data && Array.isArray(response.data)) {
        response.data = response.data.map(event => {
          if (event.image) {
            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            
            if (event.image.startsWith('http')) {
              event.image_url = event.image;
            } else {
              // Nettoyer le chemin
              const cleanedPath = event.image.startsWith('storage/') 
                ? event.image.replace('storage/', '') 
                : event.image;
              
              // Vérifier si le chemin contient déjà un dossier
              if (cleanedPath.includes('/')) {
                event.image_url = `${baseUrl}/storage/${cleanedPath}`;
              } else {
                // Par défaut, utiliser 'evenements'
                event.image_url = `${baseUrl}/storage/evenements/${cleanedPath}`;
              }
            }
          } else {
            event.image_url = '/default-event.jpg';
          }
          
          return event;
        });
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        response.data.data = response.data.data.map(event => {
          if (event.image) {
            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            
            if (event.image.startsWith('http')) {
              event.image_url = event.image;
            } else {
              const cleanedPath = event.image.startsWith('storage/') 
                ? event.image.replace('storage/', '') 
                : event.image;
              
              if (cleanedPath.includes('/')) {
                event.image_url = `${baseUrl}/storage/${cleanedPath}`;
              } else {
                event.image_url = `${baseUrl}/storage/evenements/${cleanedPath}`;
              }
            }
          } else {
            event.image_url = '/default-event.jpg';
          }
          
          return event;
        });
      }
      
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/evenements/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
 create: async (data) => {
    try {
      const response = await api.post('/evenements', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error; 
    }
  },
  update: async (id, data) => {
    try {
      const response = await api.put(`/evenements/${id}`, data);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
 delete: async (id) => {
  try {
    const response = await api.delete(`/evenements/${id}`);
    
    // Vérification explicite de la réponse
    if (response.data && response.data.success) {
      return response.data;
    }
    
    // Si la structure de réponse n'est pas celle attendue
    throw new Error(response.data?.message || 'Réponse inattendue du serveur');
  } catch (error) {
    console.error('Erreur lors de la suppression:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    // Renvoie un objet d'erreur structuré
    throw {
      message: error.response?.data?.message || error.message,
      status: error.response?.status,
      data: error.response?.data
    };
  }
},

  inscrire: async (evenementId, notes) => {
    try {
      const response = await api.post(`/evenements/${evenementId}/inscription`, { notes });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  desinscrire: async (evenementId) => {
    try {
      const response = await api.delete(`/evenements/${evenementId}/inscription`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  checkInscription: async (evenementId) => {
    try {
      const response = await api.get(`/evenements/${evenementId}/check-inscription`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  getInscriptions: async () => {
    try {
      const response = await api.get('/mes-inscriptions');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};

// Service des utilisateurs
export const userService = {
  getAll: async () => {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  delete: async (id) => {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};

// Service des messages
// Service des messages - MIS À JOUR avec gestion des notifications
export const messageService = {
  send: async (content, recipientId) => {
    try {
      const response = await api.post('/messages', {
        contenu: content,
        destinataire_id: recipientId
      });
      
      // Vérifier si la notification a été envoyée
      if (response.data && response.data.notification_sent !== undefined) {
        console.log('Notification email:', 
          response.data.notification_sent ? '✅ Envoyée' : '❌ Non envoyée');
      }
      
      return response.data;
    } catch (error) {
      console.error('Erreur envoi message:', error.response?.data || error.message);
      throw new Error(`Échec de l'envoi du message: ${error.response?.data?.message || error.message}`);
    }
  },

  getReceived: async () => {
    try {
      const response = await api.get('/messages/received');
      
      // Normaliser la réponse selon votre API
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      
      return [];
    } catch (error) {
      console.error('Erreur réception messages:', error.response?.data || error.message);
      throw new Error(`Échec de la récupération des messages reçus: ${error.response?.data?.message || error.message}`);
    }
  },

  getSent: async () => {
    try {
      const response = await api.get('/messages/sent');
      
      // Normaliser la réponse selon votre API
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      
      return [];
    } catch (error) {
      console.error('Erreur messages envoyés:', error.response?.data || error.message);
      throw new Error(`Échec de la récupération des messages envoyés: ${error.response?.data?.message || error.message}`);
    }
  },

  getOne: async (id) => {
    try {
      const response = await api.get(`/messages/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Échec de la récupération du message: ${error.response?.data?.message || error.message}`);
    }
  },

    // NOUVELLE MÉTHODE : Récupérer les infos d'un utilisateur avec qui on discute
  getConversationUser: async (userId) => {
    try {
      const response = await api.get(`/conversation-user/${userId}`);
      
      if (response.data && response.data.success) {
        return response.data.data;
      }
      
      throw new Error(response.data?.message || 'Erreur lors de la récupération des informations de conversation');
    } catch (error) {
      console.error('Erreur récupération utilisateur conversation:', error.response?.data || error.message);
      throw new Error(
        `Échec de la récupération des informations de conversation: ${error.response?.data?.message || error.message}`
      );
    }
  },

  // NOUVELLE MÉTHODE : Récupérer les infos de tous les utilisateurs avec qui on discute
  getConversationUsers: async () => {
    try {
      const response = await api.get('/conversation-users');
      
      if (response.data && response.data.success) {
        return response.data.data;
      }
      
      // Gestion de la réponse sans la structure 'success'
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      
      return [];
    } catch (error) {
      console.error('Erreur récupération utilisateurs conversation:', error.response?.data || error.message);
      throw new Error(
        `Échec de la récupération des utilisateurs de conversation: ${error.response?.data?.message || error.message}`
      );
    }
  },

    // Méthode existante pour supprimer un message (si non présente)
  delete: async (id) => {
    try {
      const response = await api.delete(`/messages/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur suppression message:', error.response?.data || error.message);
      throw new Error(`Échec de la suppression du message: ${error.response?.data?.message || error.message}`);
    }
  }
};

// Service des sous-services
export const sousServiceService = {
  getAll: async () => {
    try {
      const response = await api.get('/sous-services');
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error; // Important: propager l'erreur
    }
  },
  getOne: async (id) => {
    try {
      const response = await api.get(`/sous-services/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  create: async (data) => {
    try {
      const response = await api.post('/sous-services', data);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  update: async (id, data) => {
    try {
      const response = await api.put(`/sous-services/${id}`, data);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  delete: async (id) => {
    try {
      const response = await api.delete(`/sous-services/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};

// Service des contacts
export const contactService = {
  getAll: async () => {
    try {
      const response = await api.get('/contacts');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  getOne: async (id) => {
    try {
      const response = await api.get(`/contacts/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },
   create: async (data) => {
    try {
      const response = await api.post('/contacts', {
        name: data.name,
        email: data.email,
        phone: data.phone,
        subject: data.subject,
        message: data.message,
        to: data.to,
        email_subject: data.emailSubject,
        email_content: data.emailContent
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 422) {
        // Renvoyer les erreurs de validation du serveur
        throw {
          response: {
            data: {
              errors: error.response.data.errors,
              message: 'Validation error'
            }
          }
        };
      }
      throw error;
    }
  },
  markAsRead: async (id) => {
    try {
      const response = await api.put(`/contacts/${id}/read`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};


// CORRECTION IMPORTANTE : Service pour le forum de discussion
export const forumService = {
  // Récupérer toutes les discussions
  getDiscussions: async (params = {}) => {
    try {
      const response = await api.get('/forum', { params });
      
      console.log('API Discussions Response:', response.data);
      
      if (response.data.success && response.data.data) {
        return response.data.data;
      } else if (Array.isArray(response.data)) {
        return {
          data: response.data,
          current_page: 1,
          total: response.data.length
        };
      } else if (response.data.data && Array.isArray(response.data.data)) {
        return response.data;
      }
      
      return { data: [], current_page: 1, total: 0 };
    } catch (error) {
      console.error('Error fetching discussions:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors du chargement des discussions');
    }
  },

  // CORRIGÉ : Récupérer les catégories du forum (table discussion_categories)
  // CORRIGÉ : Normaliser les catégories
  getCategories: async () => {
    try {
      const response = await api.get('/forum/categories');
      
      console.log('API Forum Categories Response RAW:', response.data);
      
      // Normaliser la réponse
      let categories = [];
      
      if (response.data.success && response.data.data) {
        categories = response.data.data;
      } else if (Array.isArray(response.data)) {
        categories = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        categories = response.data.data;
      }
      
      // CORRECTION IMPORTANTE : Normaliser le nom
      // L'API retourne 'nom' mais le frontend attend 'name'
      const normalizedCategories = categories.map(category => ({
        id: category.id,
        name: category.nom || category.name, // Utilise 'nom' si 'name' n'existe pas
        nom: category.nom || category.name, // Garde aussi 'nom' pour compatibilité
        description: category.description,
        slug: category.slug,
        order: category.order,
        created_at: category.created_at,
        updated_at: category.updated_at
      }));
      
      console.log('Catégories normalisées:', normalizedCategories);
      
      return normalizedCategories;
    } catch (error) {
      console.error('Error fetching forum categories:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors du chargement des catégories du forum');
    }
  },


  // CORRIGÉ : Créer une discussion (utilise discussion_categories)
  createDiscussion: async (discussionData) => {
    try {
      const response = await api.post('/discussions', discussionData);
      return response.data;
    } catch (error) {
      console.error('Error creating discussion:', error.response?.data || error.message);
      
      // Gestion d'erreur améliorée
      if (error.response) {
        if (error.response.status === 422) {
          throw new Error(`Validation error: ${JSON.stringify(error.response.data.errors)}`);
        }
        if (error.response.status === 401) {
          throw new Error('Session expirée. Veuillez vous reconnecter.');
        }
        throw new Error(error.response.data.message || 'Erreur lors de la création de la discussion');
      }
      
      throw new Error(error.message || 'Erreur de connexion au serveur');
    }
  },

  // Récupérer une discussion spécifique
  getDiscussion: async (id) => {
    try {
      // IMPORTANT: Utilisez '/forum/discussions/{id}'
      const response = await api.get(`/forum/discussions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching discussion:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors du chargement de la discussion');
    }
  },

  // Mettre à jour une discussion
  updateDiscussion: async (id, discussionData) => {
    try {
      const response = await api.put(`/forum/discussions/${id}`, discussionData);
      return response.data;
    } catch (error) {
      console.error('Error updating discussion:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de la mise à jour de la discussion');
    }
  },

  // Supprimer une discussion
  deleteDiscussion: async (id) => {
    try {
      const response = await api.delete(`/forum/discussions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting discussion:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de la suppression de la discussion');
    }
  },

  // Ajouter une réponse à une discussion
  createReply: async (discussionId, content, aiGenerated = false) => {
    try {
      const response = await api.post(`/discussions/${discussionId}/replies`, { 
        content,
        ai_generated: aiGenerated 
      });
      return response.data;
    } catch (error) {
      console.error('Error creating reply:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de l\'ajout de la réponse');
    }
  },

  // Mettre à jour une réponse
  updateReply: async (id, content) => {
    try {
      const response = await api.put(`/forum/replies/${id}`, { content });
      return response.data;
    } catch (error) {
      console.error('Error updating reply:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de la mise à jour de la réponse');
    }
  },

  // Supprimer une réponse
  deleteReply: async (id) => {
    try {
      const response = await api.delete(`/forum/replies/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting reply:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de la suppression de la réponse');
    }
  },

  // Actions d'administration
  adminAction: async (id, action) => {
    try {
      const response = await api.post(`/forum/discussions/${id}/admin`, { action });
      return response.data;
    } catch (error) {
      console.error('Error admin action:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || 'Erreur lors de l\'action d\'administration');
    }
  }
};

// Service Gemini/IA intégré
export const geminiService = {
  sessionId: 'gemini_chat_' + Date.now(),

  async validateApiKey() {
    try {
      const response = await api.post('/gemini/validate-key');
      return response.data;
    } catch (error) {
      return {
        valid: false,
        message: '❌ Impossible de contacter le serveur'
      };
    }
  },

  async sendMessage(message, sessionId = null) {
    try {
      const response = await api.post('/gemini/send-message', {
        message: message,
        session_id: sessionId || this.sessionId
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: '❌ Erreur de connexion au serveur'
      };
    }
  },

  async resetChat(sessionId = null) {
    try {
      await api.post('/gemini/reset-chat', {
        session_id: sessionId || this.sessionId
      });
    } catch (error) {
      console.error('Erreur reset:', error);
    }
  },

  generateNewSession() {
    this.sessionId = 'gemini_chat_' + Date.now();
    return this.sessionId;
  }
};

// Service IA pour les annonces et forum
export const aiService = {
  generateAd: async (adType, specifics = [], sousServiceId) => {
    try {
      const response = await api.post('/ai/generate-ad', {
        ad_type: adType,
        specifics: specifics,
        sous_service_id: sousServiceId
      });
      return response.data;
    } catch (error) {
      console.error('Erreur génération annonce IA:', error);
      throw new Error(error.response?.data?.message || 'Erreur lors de la génération de l\'annonce');
    }
  },

  generateForumReply: async (discussionId, comment, commentId = null) => {
    try {
      const response = await api.post(`/discussions/${discussionId}/generate-ai-reply`, {
        comment: comment,
        comment_id: commentId
      });
      return response.data;
    } catch (error) {
      console.error('Erreur génération réponse IA:', error);
      throw new Error(error.response?.data?.message || 'Erreur lors de la génération de la réponse');
    }
  }
};

// Intercepteur pour ajouter automatiquement le token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});


const handleApiError = (error) => {
  if (error.response) {
    throw error.response.data;
  } else if (error.request) {
    throw { message: 'Pas de réponse du serveur' };
  } else {
    throw { message: error.message };
  }
};


// Service pour les experts
export const expertService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/experts', { params });
      
      console.log('API Response - Experts list:', response.data);
      
      // NORMALISATION DES URLS D'IMAGES - Même logique que pour les annonces
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        response.data.data = response.data.data.map(expert => {
          // CORRECTION : Utiliser le même dossier que les annonces
          if (expert.image) {
            // Si l'image est déjà une URL complète
            if (expert.image.startsWith('http')) {
              expert.image_url = expert.image;
            } 
            // Si c'est un chemin relatif - CHANGER 'profile_images' en 'annonces'
            else {
              const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
              const fileName = expert.image.split('/').pop();
              // CORRECTION ICI : Utiliser 'annonces' au lieu de 'profile_images'
              expert.image_url = `${baseUrl}/storage/annonces/${fileName}`;
            }
          }
          
          // Si l'API a déjà fourni image_url, utilisez-le
          if (!expert.image_url && expert.image_url_from_api) {
            expert.image_url = expert.image_url_from_api;
          }
          
          // Ajouter une image par défaut si aucune image n'est disponible
          if (!expert.image_url) {
            expert.image_url = '/default-expert.jpg';
          }
          
          return expert;
        });
      }
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des experts:', error.response?.data || error.message);
      throw new Error(error.response?.data?.message || 'Erreur lors du chargement des experts');
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/experts/${id}`);
      
      console.log('API Response - Expert details:', response.data);
      
      let expertData;
      
      // Vérifier la structure de la réponse
      if (response.data && response.data.success !== undefined) {
        expertData = response.data.data || response.data;
      } else {
        expertData = response.data;
      }
      
      // NORMALISATION DES URLS D'IMAGES - Même logique que pour les annonces
      if (expertData) {
        // Image principale - CORRECTION ICI
        if (expertData.image) {
          if (expertData.image.startsWith('http')) {
            expertData.image_url = expertData.image;
          } else {
            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            const fileName = expertData.image.split('/').pop();
            // CORRECTION : Utiliser 'annonces' au lieu de 'profile_images'
            expertData.image_url = `${baseUrl}/storage/annonces/${fileName}`;
          }
        }
        
        // Si l'API a déjà fourni image_url, utilisez-le
        if (!expertData.image_url && expertData.image_url_from_api) {
          expertData.image_url = expertData.image_url_from_api;
        }
        
        // Ajouter une image par défaut si nécessaire
        if (!expertData.image_url) {
          expertData.image_url = '/default-expert.jpg';
        }
      }
      
      return expertData;
    } catch (error) {
      console.error('Erreur récupération détail expert:', error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message || 
        'Erreur lors du chargement des détails de l\'expert'
      );
    }
  },

  search: async (filters = {}) => {
    try {
      const response = await api.get('/experts/search', { 
        params: filters 
      });
      
      // Normaliser les URLs d'images dans les résultats de recherche
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        response.data.data = response.data.data.map(expert => {
          if (expert.image) {
            if (expert.image.startsWith('http')) {
              expert.image_url = expert.image;
            } else {
              const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
              const fileName = expert.image.split('/').pop();
              // CORRECTION : Utiliser 'annonces' au lieu de 'profile_images'
              expert.image_url = `${baseUrl}/storage/annonces/${fileName}`;
            }
          }
          
          if (!expert.image_url) {
            expert.image_url = '/default-expert.jpg';
          }
          
          return expert;
        });
      }
      
      return response.data;
    } catch (error) {
      console.error('Erreur recherche experts:', error.response?.data || error.message);
      throw new Error(error.response?.data?.message || 'Erreur lors de la recherche des experts');
    }
  }
};





export default api;

